/* eslint-disable jsx-a11y/anchor-is-valid, jsx-a11y/label-has-for */
/* eslint-disable react/forbid-prop-types */
import _ from 'underscore';
import $ from 'jquery';
import React, { createRef } from 'react';
import PropTypes from 'prop-types';
import { ValidatedUrlEditor } from '@bingads-webui-react/url-editor';
import { Alert } from '@bingads-webui-react/alert';
import { HelpPopup } from '@bingads-webui-react/help-popup';
import { TextArea } from '@bingads-webui-react/primitive-validation';
import {
  ValidatedInput,
  ValidationGroup,
  ValidatedRadioGroup
} from '@bingads-webui-react/validation-controls';
import { withUiBlock } from '@bingads-webui/uiblocker';
import { ErrorMessages } from '@bingads-webui-react/validation';
import { cloneDeep } from '@bingads-webui-universal/primitive-utilities';
import { DropdownSelector } from '@bingads-webui-react/dropdown-selector';
import { RemainingCharsHint } from '@bingads-webui-campaign-react/remaining-chars-hint';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';

const LayoutType = {
  popup: 'Popup',
  line: 'AdditionalLine',
};

const getStyles = () => ({
  hideLayoutOption: {
    '& label': {
      paddingLeft: 15,
    },

    '& input': {
      display: 'none',
    },
  },
});

class UnStyledDisclaimerEditor extends React.PureComponent {
  static propTypes = {
    editData: PropTypes.object,
    onClose: PropTypes.func.isRequired,
    isNativeAd: PropTypes.bool,
    onDisclaimerAddOrUpdated: PropTypes.func,
    i18n: PropTypes.shape({
      getString: PropTypes.func.isRequired,
    }).isRequired,
    schema: PropTypes.object.isRequired,
    repository: PropTypes.shape({
      create: PropTypes.func.isRequired,
    }).isRequired,
    usePanel: PropTypes.bool,
    permissions: PropTypes.shape({}),
    classes: PropTypes.shape({}).isRequired,
    showOnlyPopupLayout: PropTypes.bool,
    perfMarker: PropTypes.shape({
      willInit: PropTypes.func,
      done: PropTypes.func,
    }),
  };

  static defaultProps = {
    editData: null,
    onDisclaimerAddOrUpdated: _.noop,
    usePanel: false,
    isNativeAd: false,
    permissions: {},
    showOnlyPopupLayout: false,
    perfMarker: null,
  };

  constructor(props) {
    super(props);

    this.dropdownitems = [
      {
        Id: 'disclaimer-editor-title',
        value: this.props.i18n.getString('Disclaimers_Title_Default'),
      },
      {
        Id: 'disclaimer-editor-disclaimer',
        value: this.props.i18n.getString('Disclaimers_Dropdown_Disclaimer'),
      },
      {
        Id: 'disclaimer-editor-disclosure',
        value: this.props.i18n.getString('Disclaimers_Dropdown_Disclosure'),
      },
      {
        Id: 'disclaimer-editor-moreDisclaimer',
        value: this.props.i18n.getString('Disclaimers_Dropdown_MoreDisclaimer'),
      },
      {
        Id: 'disclaimer-editor-offer',
        value: this.props.i18n.getString('Disclaimers_Dropdown_Offer'),
      },
      {
        Id: 'disclaimer-editor-safetyInfor',
        value: this.props.i18n.getString('Disclaimers_Dropdown_SafetyInfor'),
      },
      {
        Id: 'disclaimer-editor-safetyInformation',
        value: this.props.i18n.getString('Disclaimers_Dropdown_SafetyInformation'),
      },
    ];

    // Hide popup option in Ads CN and when creation mode or edit mode but the layout is line, which means when layout is popup, we allow to switch to line.
    this.hidePopupOption = _.get(props.permissions, 'IsDomesticSimplifiedChineseEnabled', false) && (_.isEmpty(this.props.editData) || this.props.editData.DisclaimerLayout === LayoutType.line);
    // We will not allow domestic simplified chinese user to use native ad disclaimer.
    if (props.isNativeAd || props.showOnlyPopupLayout) {
      this.layoutTypeOptions = [LayoutType.popup];
    } else {
      this.layoutTypeOptions = this.hidePopupOption ? [LayoutType.line] : [LayoutType.popup, LayoutType.line];
    }

    const defaultData = {
      Name: '',
      Title: this.props.i18n.getString('Disclaimers_Title_Default'),
      PopupText: '',
      LineText: '',
      DisclaimerLayout: this.hidePopupOption ? LayoutType.line : LayoutType.popup,
      FinalUrls: [],
      FinalMobileUrls: [],
    };

    // find the item in the list, otherwise, select the first one.
    const dropdownSeleted = (this.props.editData ? _.findWhere(
      this.dropdownitems,
      { value: this.props.editData.Title }
    ) : null) || this.dropdownitems[0];

    this.state = {
      disclaimer: this.props.editData ? cloneDeep(this.props.editData) : defaultData,
      isValid: '',
      errors: [],
      alwaysShowError: false,
      selected: dropdownSeleted,
    };

    const popupSchema = {
      ...this.props.schema,
      properties: {
        ...this.props.schema.properties,
        Name: {
          ...this.props.schema.properties.Name,
          required: true,
        },
        DisclaimerLayout: {
          ...this.props.schema.properties.DisclaimerLayout,
          required: true,
        },
        Title: {
          ...this.props.schema.properties.Title,
          required: true,
        },
        PopupText: {
          ...this.props.schema.properties.PopupText,
          required: true,
        },
      },
    };
    const lineSchema = {
      ...this.props.schema,
      properties: {
        ...this.props.schema.properties,
        Name: {
          ...this.props.schema.properties.Name,
          required: true,
        },
        DisclaimerLayout: {
          ...this.props.schema.properties.DisclaimerLayout,
          required: true,
        },
        LineText: {
          ...this.props.schema.properties.LineText,
          required: true,
        },
        FinalUrls: {
          ...this.props.schema.properties.FinalUrls,
          required: true,
        },
      },
    };

    this.schema = {
      [LayoutType.popup]: popupSchema,
      [LayoutType.line]: lineSchema,
    };

    this.ref = createRef();
  }

  onSubmit = () => {
    this.setState({ alwaysShowError: true }, () => {
      this.getFirstAlertElementAndFocus();
    });

    if (this.state.isValid === 'false') {
      return;
    }

    if (this.state.disclaimer.DisclaimerLayout === LayoutType.popup) {
      this.state.disclaimer.Title = this.state.selected.value;
    }

    const dataToBeSaved = this.state.disclaimer;

    if (this.props.editData && this.props.editData.Id > 0) {
      // eslint-disable-next-line no-alert, no-restricted-globals
      if (confirm(this.props.i18n.getString('Disclaimers_Edit_Confirmation'))) {
        dataToBeSaved.Id = this.props.editData.Id;
      } else {
        return;
      }
    }

    if (this.props.perfMarker) {
      this.props.perfMarker.willInit();
    }

    this.props.repository.create(dataToBeSaved)
      .then(() => {
        if (this.props.perfMarker) {
          this.props.perfMarker.done();
        }

        this.props.onClose();
        this.props.onDisclaimerAddOrUpdated(dataToBeSaved);
      })
      .catch((errors) => {
        if (this.props.perfMarker) {
          this.props.perfMarker.done();
        }

        this.setState({
          errors: _.chain(errors)
            .uniq(value => value.message)
            .map(error => (error.isHtmlMessage ? { DangerousHtmlMessage: error.message } : error.message))
            .value(),
        });
      })
      .finally(withUiBlock($(this.props.usePanel ? '.disclaimer-editor-panel .panel-content' : '.disclaimer-editor-modal'), this.props.i18n.getString('Loading')));
  };

  onValidate = (result) => {
    this.setState(preState => ({
      isValid: result.isValid.toString(),
      disclaimer: preState.disclaimer.DisclaimerLayout !== result.data.DisclaimerLayout
        && result.data.DisclaimerLayout === LayoutType.popup ?
        _.defaults({ Title: this.props.i18n.getString('Disclaimers_Title_Default') }, result.data)
        : result.data,
      errors: [],
    }));
  };

  onLayoutTypeChange = () => {
    this.setState({
      alwaysShowError: false,
      selected: this.dropdownitems[0],
    });
  };

  onSelectedChange = (selected) => {
    this.setState({
      selected,
    });
  };

  getFirstAlertElementAndFocus = () => {
    const alertNode = this.ref.current.querySelector('.col-sm-8 [role="alert"]');
    if (alertNode) {
      alertNode.parentElement.firstChild.focus();
    }

    return null;
  };

  renderlayoutOptions = item => (
    <React.Fragment>
      {this.props.i18n.getString(`Disclaimers_DisplayLayout_${item}`)}
      {item === LayoutType.line
        && this.state.disclaimer.DisclaimerLayout === LayoutType.line
        && <Alert
          level="Info"
          dismissible={false}
          icon={(<div className="alert-image" />)}
          message={this.props.i18n.getString('Disclaimers_DisplayLayout_AdditionalLine_Hint')}
        />}
    </React.Fragment>
  );

  renderSettingItem = ({
    settingName,
    labelText,
    helpId = '',
    children,
  }) => (
    <div className={`form-group setting-disclaimer-${settingName}`}>
      <label className="col-sm-4 control-label">
        {this.props.i18n.getString(labelText)}
        {helpId && <HelpPopup
          topic={helpId}
          aria-label={`${this.props.i18n.getString('LearnMoreLinkText')} ${this.props.i18n.getString(labelText)}`}
        />}
      </label>
      <div className="col-sm-8">
        {children}
      </div>
    </div>
  );

  render() {
    const header = this.props.usePanel || (
      <div className="disclaimer-setting-header panel-title">
        <button
          className="close closeimage"
          onClick={this.props.onClose}
          aria-label={this.props.i18n.getString('Button_Close')}
        />
        <div className="disclaimer-editor-title">
          {this.props.i18n.getString(this.props.editData ? 'Disclaimers_Edit' : 'Disclaimers_Create')}
        </div>
      </div>
    );

    const footer = (
      <div className="disclaimer-setting-footer">
        <button
          className="btn btn-primary"
          onClick={this.onSubmit}
        >
          {this.props.i18n.getString('Save')}
        </button>
        <button className="btn btn-default" onClick={this.props.onClose}>
          {this.props.i18n.getString('Cancel')}
        </button>
      </div>
    );

    const customNameErrors = {
      required: this.props.i18n.getString('DisclaimerNameRequired'),
    };

    const errorProcessorForName = errors => _.map(
      errors,
      (oldError, key) => customNameErrors[key] || oldError
    );

    const nameSetting = this.renderSettingItem({
      settingName: 'name',
      labelText: 'Disclaimers_Name_Label',
      helpId: 'pop_BA_DisclaimerAd_Name',
      children: (<ValidatedInput
        className="form-control"
        validationProps={{
          field: 'Name',
          alwaysShowError: this.state.alwaysShowError,
          errorProcessor: errorProcessorForName,
        }}
        id="disclaimer-editor-name"
        ariaLabel={this.props.i18n.getString('Disclaimers_Name_Label')}
      />),
    });

    const getPopUpLayoutHelpId = (hidePopupOption, isNativeAd) => {
      if (hidePopupOption) {
        return 'pop_BA_DisclaimerAd_LayoutChina';
      }

      return isNativeAd ? 'pop_BA_Audience_DisclaimerLayout' : 'pop_BA_DisclaimerAd_Layout';
    };

    const layoutTypeSetting = this.renderSettingItem({
      settingName: 'layoutType',
      labelText: 'Disclaimers_DisplayLayout_Label',
      helpId: getPopUpLayoutHelpId(this.hidePopupOption, this.props.isNativeAd),
      children: (
        <div role="radiogroup" className={this.hidePopupOption ? this.props.classes.hideLayoutOption : ''}>
          <ValidatedRadioGroup
            className="form-control"
            validationProps={{
              field: 'DisclaimerLayout',
              alwaysShowError: this.state.alwaysShowError,
            }}
            id="disclaimer-editor-layoutType"
            items={this.layoutTypeOptions}
            renderItem={this.renderlayoutOptions}
            onChange={this.onLayoutTypeChange}
          />
        </div>
      ),
    });

    const getTitlePopupHelpId = (isNativeAd) => {
      if (isNativeAd) {
        return { helpId: 'pop_BA_Audience_DisclaimerTitle' };
      }
      return {};
    };

    const titleSetting = this.renderSettingItem({
      settingName: 'title',
      labelText: 'Disclaimers_Title_Label',
      children: (
        <DropdownSelector
          className="form-control"
          selectedItem={this.state.selected}
          onSelect={this.onSelectedChange}
          totalCount={_.size(this.dropdownitems)}
          items={this.dropdownitems}
          i18n={this.props.i18n}
          enableArrowKeysSupport
          shouldFocusFirstFocusableItemOnMount
          id="disclaimer-editor-title"
        />
      ),
      ...getTitlePopupHelpId(this.props.isNativeAd),
    });

    const customDescriptionErrors = {
      required: this.props.i18n.getString('DisclaimerInformationRequired'),
    };

    const errorProcessorForDescription = errors => _.map(
      errors,
      (oldError, key) => customDescriptionErrors[key] || oldError
    );

    const getInformationPopupSetting = (isNativeAd) => {
      if (isNativeAd) {
        return { helpId: 'pop_BA_Audience_DisclaimerInfo' };
      }
      return {};
    };

    const popupSetting = this.renderSettingItem({
      settingName: 'information-popup',
      labelText: 'Disclaimers_Information_Label',
      ...getInformationPopupSetting(this.props.isNativeAd),
      children: (
        <React.Fragment>
          <TextArea
            className="form-control"
            validationProps={{
              field: 'PopupText',
              alwaysShowError: this.state.alwaysShowError,
              errorProcessor: errorProcessorForDescription,
            }}
            id="disclaimer-editor-information-popup"
            aria-label={this.props.i18n.getString('Disclaimers_Information_Label')}
          />
          <RemainingCharsHint
            str={this.state.disclaimer.PopupText}
            i18n={this.props.i18n}
            schema={_.pick(
              this.schema[this.state.disclaimer.DisclaimerLayout].properties.PopupText,
              'maxLength',
              'distinguishWideChar'
            )}
          />
        </React.Fragment>
      ),
    });

    const lineSetting = this.renderSettingItem({
      settingName: 'information-additionalline',
      labelText: 'Disclaimers_Information_Label',
      children: (
        <React.Fragment>
          <TextArea
            className="form-control"
            validationProps={{
              field: 'LineText',
              alwaysShowError: this.state.alwaysShowError,
              errorProcessor: errorProcessorForDescription,
            }}
            id="disclaimer-editor-information-additionalline"
          />
          <RemainingCharsHint
            str={this.state.disclaimer.LineText}
            i18n={this.props.i18n}
            schema={_.pick(
              this.schema[this.state.disclaimer.DisclaimerLayout].properties.LineText,
              'maxLength',
              'distinguishWideChar'
            )}
          />
        </React.Fragment>
      ),
    });

    const customFinalUrlErrors = {
      required: this.props.i18n.getString('FinalURLRequired'),
    };

    const errorProcessorForFinalUrl = errors => _.map(
      errors,
      (oldError, key) => customFinalUrlErrors[key] || oldError
    );

    const finalUrlSetting = this.renderSettingItem({
      settingName: 'finalurl',
      labelText: 'Ad_FinalUrl',
      helpId: 'pop_BA_DisclaimerAd_FinalURL',
      children: (
        <ValidatedUrlEditor
          validationProps={{
            field: 'FinalUrls',
            alwaysShowError: this.state.alwaysShowError,
            errorProcessor: errorProcessorForFinalUrl,
          }}
          key="finalUrls"
        />
      ),
    });

    const mobileUrlSetting = this.renderSettingItem({
      settingName: 'mobileurl',
      labelText: 'MobileFinalUrl_Label',
      helpId: this.props.isNativeAd? 'pop_BA_Audience_DisclaimerMobile' : 'pop_BA_DIsclaimerAd_MobileURL',
      children: (
        <ValidatedUrlEditor
          validationProps={{
            field: 'FinalMobileUrls',
            alwaysShowError: this.state.alwaysShowError,
          }}
          key="finalMobileUrls"
        />
      ),
    });

    return (
      <React.Fragment>
        {header}
        <div className="form-horizontal disclaimer-setting-content" ref={this.ref}>
          {this.state.disclaimer.DisclaimerLayout === LayoutType.popup ?
            <ValidationGroup
              validationProps={{
                schema: this.schema[LayoutType.popup],
                i18n: this.props.i18n,
                onValidate: this.onValidate,
                data: this.state.disclaimer,
                alwaysShowError: this.state.alwaysShowError,
              }}
            >
              {nameSetting}
              {layoutTypeSetting}
              {titleSetting}
              {popupSetting}
              {finalUrlSetting}
              {mobileUrlSetting}
            </ValidationGroup> :
            <ValidationGroup
              validationProps={{
                schema: this.schema[LayoutType.line],
                i18n: this.props.i18n,
                onValidate: this.onValidate,
                data: this.state.disclaimer,
                alwaysShowError: this.state.alwaysShowError,
              }}
            >
              {nameSetting}
              {layoutTypeSetting}
              {lineSetting}
              {finalUrlSetting}
              {mobileUrlSetting}
            </ValidationGroup>
          }
          {this.state.errors &&
            this.state.errors.length > 0 &&
            <div className="mt-error">
              <ErrorMessages messages={this.state.errors} className="over-all-errors error" />
            </div>}
        </div>
        {footer}
      </React.Fragment>
    );
  }
}

export const DisclaimerEditor = withDefaultStyles(UnStyledDisclaimerEditor, getStyles);
